import { Col, Row, Select } from "antd";
import DaysPicker from "../../../Common/DaysPicker";

const FleetFilter = ({
  fleetList,
  fleetId,
  onChangeFleet,
  batteryField,
  onSelectBattery,
  batteryList,
  onChangeModel,
  modelList,
  model,
}) => {
  return (
    <Row gutter={[16, 16]}>
      <Col span={4}>
        {fleetList?.length > 0 && (
          <Select
            size="large"
            showSearch
            value={fleetId || fleetList?.[0]?.fleetId}
            style={{ width: "100%" }}
            onChange={onChangeFleet}
            options={fleetList.map((i) => ({
              label: i.fleetName,
              value: i.fleetId,
            }))}
          />
        )}
      </Col>
      <Col span={5}>
        <Select
          size="large"
          value={model?.modelName || modelList?.[0]?.modelName}
          style={{ width: "100%" }}
          onChange={onChangeModel}
          options={modelList?.map((i) => ({
            label: i.modelName,
            value: i.modelId,
          }))}
        />
      </Col>
      <Col span={5}>
        <Select
          size="large"
          value={batteryField}
          style={{ width: "100%" }}
          onChange={onSelectBattery}
          options={batteryList?.map((i) => ({
            label: i.title,
            value: i.value,
          }))}
        />
      </Col>

      <Col span={10} className="justify-right">
        <DaysPicker 
          localTimeState={false}
          customOptions={["Day", "Week"]}
        />
      </Col>
    </Row>
  );
};

export default FleetFilter;
